import { css } from '@emotion/react'
import { HFlow, Icon, SelectMenuItem, Text, Tooltip } from 'bold-ui'
import { SelectDownshiftMenuProps } from 'bold-ui/lib/components/Select/SelectSingle/SelectDownshiftMenu'
import { selectFieldStatus } from 'components/form/core'
import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { RenderGrupoSelectHeader } from 'components/form/field/select/RenderGrupoSelectHeader'

interface AntecedentesFamiliaresCidSelectItemProps {
  blockedCidIds: Set<ID>
  itemIsDisabled?: (item: CidSelectFieldModel) => boolean
  hasCidsRelacionadas: boolean
  hasOutrasCids: boolean
  ciapRelacionada?: ID
  itemProps: SelectDownshiftMenuProps<CidSelectFieldModel> & { item: CidSelectFieldModel; index: number }
}

const ID_GRUPO_CIDS_RELACIONADAS = 'grupoCidsRelacionadas'
const ID_GRUPO_OUTRAS_CIDS = 'grupoOutrasCids'

const createStyles = () => ({
  disabledMenuItem: css`
    cursor: not-allowed;
  `,
  customItemDisabledStyle: css`
    opacity: 0.5;
  `,
  customItemWrapStyle: css`
    display: flex;
    flex-wrap: wrap;
  `,
  selectedItemLabel: css`
    color: ${selectFieldStatus.SUCCESS.color};
  `,
  selectedItemIcon: css`
    display: block;
  `,
})

export function AntecedentesFamiliaresCidSelectItem(props: Readonly<AntecedentesFamiliaresCidSelectItemProps>) {
  const { blockedCidIds, itemIsDisabled, hasCidsRelacionadas, hasOutrasCids, ciapRelacionada, itemProps } = props
  const classes = createStyles()

  const {
    index,
    downshift: { getItemProps, highlightedIndex },
    item,
    renderItem,
  } = itemProps

  const renderGrupoCidsRelacionadas = item?.id === ID_GRUPO_CIDS_RELACIONADAS
  const renderGrupoOutrasCid = item?.id === ID_GRUPO_OUTRAS_CIDS
  const isBlockedCid = blockedCidIds.has(item?.id)
  const isDisabledCid = isBlockedCid || !!itemIsDisabled?.(item)

  if (renderGrupoOutrasCid) {
    return (
      <RenderGrupoSelectHeader
        titulo='Outras CID10'
        emptyMessage={!hasOutrasCids && 'Nenhuma outra CID10.'}
        itemProps={getItemProps({ item, disabled: true })}
      />
    )
  }

  if (renderGrupoCidsRelacionadas) {
    return (
      <RenderGrupoSelectHeader
        titulo='CID10 relacionadas com a CIAP 2 selecionada'
        emptyMessage={
          !ciapRelacionada ? 'Nenhuma CIAP 2 selecionada.' : !hasCidsRelacionadas && 'Nenhuma CID10 relacionada.'
        }
        itemProps={getItemProps({ item, disabled: true })}
      />
    )
  }

  return (
    <SelectMenuItem
      selected={highlightedIndex === index}
      {...getItemProps({ item, disabled: isDisabledCid })}
      style={isDisabledCid ? classes.disabledMenuItem : undefined}
    >
      <HFlow alignItems='center' justifyContent='space-between' style={classes.customItemWrapStyle}>
        <div css={isDisabledCid ? classes.customItemDisabledStyle : undefined}>{renderItem?.(item)}</div>

        {isBlockedCid && (
          <Tooltip text='CID10 já adicionado em outro antecedente familiar incompatível.'>
            <HFlow alignItems='center' hSpacing={0.2} style={classes.selectedItemLabel}>
              <Icon icon={selectFieldStatus.SUCCESS.icon} size={1} style={classes.selectedItemIcon} />
              <Text style={classes.selectedItemLabel}>Adicionado</Text>
            </HFlow>
          </Tooltip>
        )}
      </HFlow>
    </SelectMenuItem>
  )
}
